module.exports = {
    CC: 'Credit Card',
    Venmo: 'Venmo',
    GPay: 'Google Pay',
    CashApp: 'Cash App',
    FREE_MODE: 'FREE_MODE'
}